[{"name":"","bonus":"","number":"","probabilityMin":"","probabilityStd":"","probabilityPla":"","probabilityZer":"","dayUpperLimit":"","sumUpperLimit":""}]
<template>
  <div class="wrapper">
    <el-card class="box-card" >
      <div class="nav_list">
        <el-form-item :label="'奖品设置'">
          <p class="item_title">序号</p>
          <p class="item_title">奖项</p>
          <p class="item_title">奖品(美元)</p>
<!--          <p class="item_title">奖品数量</p>-->
          <p class="item_title">角度(总360)</p>
          <p class="item_title">迷你概率(%)</p>
          <p class="item_title">标准概率(%)</p>
          <p class="item_title">铂金概率(%)</p>
          <p class="item_title">巴菲特概率(%)</p>
          <p class="item_title">当日上限</p>
          <p class="item_title">总上限</p>
        </el-form-item>
      </div>
      <div class="text" v-for="(card,index) in update.col.data">
        <div slot="header" class="clearfix titleCon">
          <div v-if="!readonly" class="btn-list">
            <el-button type="text" @click="addReward()">{{$t('crs.bt.add')}}</el-button>
            <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('crs.bt.delete')}}</el-button>
          </div>
        </div>
        <div class="item">
          <div class="item-table">
            <el-form-item :label="String(index+1)">
              <el-input class="item-input" controls-position="right" v-model="card.name" :required="true" :disabled="readonly" :placeholder="'奖项'"></el-input>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.bonus"  :required="true" :placeholder="'奖品'" :disabled="readonly"></el-input-number>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.angle"  :required="true" :placeholder="'转盘角度(总360)'"  :disabled="readonly"></el-input-number>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.probabilityMin" :precision="2" :placeholder="'迷你概率'"  :disabled="readonly"></el-input-number>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.probabilityStd" :precision="2" :placeholder="'标准概率'"  :disabled="readonly"></el-input-number>
              <el-input-number class="item-select" controls-position="right" :min="0"v-model="card.probabilityPla" :precision="2"  :placeholder="'铂金概率'"  :disabled="readonly"></el-input-number>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.probabilityZer" :precision="2" :placeholder="'巴菲特概率'"  :disabled="readonly"></el-input-number>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.dayUpperLimit"   :placeholder="'当日上限'"   :disabled="readonly"></el-input-number>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.sumUpperLimit"   :placeholder="'总上限'" :disabled="readonly"></el-input-number>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  require('@/views/crs36/cfinr/luckyDraw/template.css')
  import condition from '@/views/crs36/cfinr/luckyDraw/condition.vue'
  export default {
    name: 'prize',
    props:["update"],
    components: {
      condition
    },
    methods: {
        addReward(){
            this.update.col.data.push({"name":"","bonus":"","number":"","probabilityMin":"","probabilityStd":"","probabilityPla":"","probabilityZer":"","dayUpperLimit":"","sumUpperLimit":""});
        },
        delReward(index){
            this.update.col.data.splice(index, 1);
        }
    },
    computed:{
        readonly(){
            return (this.update.updateModel.id && this.update.updateModel.isBy == 1)?true:false;
        }
    },
    data () {
      return {
          taskList: [],
      }
    }
  }
</script>
